import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}

export const STATUS_COLORS = {
  Submitted: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "Under Review": "bg-violet-500/10 text-violet-400 border-violet-500/30",
  Approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Rejected: "bg-rose-500/10 text-rose-400 border-rose-500/30",
  Released: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  "Taken Down": "bg-zinc-700/40 text-zinc-300 border-zinc-600",
  Pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "In Review": "bg-violet-500/10 text-violet-400 border-violet-500/30",
  "In Process": "bg-cyan-500/10 text-cyan-400 border-cyan-500/30",
  "Takedown Completed": "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  Cancelled: "bg-zinc-700/40 text-zinc-300 border-zinc-600",
  "Removed / Resolved": "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
};

export const STATUS_OPTIONS = ["Submitted", "Under Review", "Approved", "Rejected", "Released"];
export const COPYRIGHT_STATUS = ["Pending", "In Review", "Removed / Resolved", "Rejected"];
export const LANGUAGES = ["English", "Hindi", "Bhojpuri", "Rajasthani", "Punjabi", "Haryanvi", "Tamil", "Telugu", "Bengali", "Marathi", "Gujarati", "Spanish", "French", "Other"];

export const TITLE_CASE_FIELDS = ["song_title", "artist_name", "primary_artist_name", "singer_name", "composer_name", "lyricist_name", "music_director", "label_name"];
export const toTitleCase = (s) => (s || "").split(" ").map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w)).join(" ");
export const GENRES = ["Aalha", "Aarti", "Bhajan", "Chalisa", "Comedy", "Dance", "Dance Pop", "Devotional", "DJ Remix", "Folk", "Ghazal", "Hip-Hop", "Instrumental", "Kajri", "Katha", "Lofi", "Lokgeet", "Mantra", "Naat", "Nirgun", "Pop", "Pop-Rap", "Poetry", "Qawwali", "Ragni", "Rap", "Rasiya", "Regional Pop", "Remix", "Rock", "Satsangi Bhajan", "Bollywood", "R&B", "Electronic", "Indie", "Classical", "Jazz", "Other"];

export const DEITY_NAMES = ["Agni", "Ambe Maa", "Annapurna", "Balaji", "Bhairav", "Brahma", "Chandra Dev", "Dhanvantari", "Durga", "Ganesh", "Ganga Mata", "Gayatri", "Goga Ji", "Gorakhnath", "Hanuman", "Jagannath", "Kaila Devi", "Kali Mata", "Ketu Dev", "Khatu Shyam", "Krishna", "Kuber", "Lakshman", "Laxmi Mata", "Mahadev", "Mansa Devi", "Narayan", "Narsimha", "Parvati", "Radha", "Radha Krishna", "Rahu Dev", "Ram", "Sai Baba", "Santoshi Mata", "Saraswati", "Shakumbari Mata", "Shani Dev", "Sheetla Mata", "Shiv", "Sita", "Sita Ram", "Surya Dev", "Tulsi Maa", "Vaishno Devi", "Vishnu", "Vitthal", "Yamuna"];
